import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./subsciption_plans.scss";
import logo from "../../assets/fitoja-logo.jpg";
import maleProfilePic from "../../assets/profile_pic_male.jpeg";
import closeIcon from "../../assets/close_icon.png";
import deleteIcon from "../../assets/delete_icon.png";
import ReactQuill from "react-quill";
import parse from "html-react-parser";

interface SubscriptionPlans {
  _id: string;
  planName: string;
  mrp: number;
  price: number;
  description: string;
  durationInMonths: number;
  discount: number;
}

const SubscriptionPlans = () => {
  const [userDetails, setUserDetails] = useState<any>(null);
  const [subscriptionPlans, setSubscriptionPlanss] = useState<
    SubscriptionPlans[]
  >([]);
  const [role, setRole] = useState<string>("");
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true); // Add loading state
  const [subscriptionPlansToDelete, setSubscriptionPlansToDelete] =
    useState<SubscriptionPlans | null>(null);
  const [addModalVisible, setAddModalVisible] = useState<boolean>(false); // Add SubscriptionPlans Modal
  const [newSubscriptionPlans, setNewSubscriptionPlans] = useState({
    planName: "",
    mrp: "",
    price: "",
    discount: "",
    description: "",
    durationInMonths: "",
  }); // New SubscriptionPlans state
  const navigate = useNavigate();
  const isInitialRender = useRef(true);

  // Fetch user details and subscriptionPlans
  const fetchUserDetails = async () => {
    try {
      const email = localStorage.getItem("email");
      const token = localStorage.getItem("token");
      if (!email || !token) {
        alert("Authentication failed! Redirecting to login.");
        navigate("/login");
        return;
      }

      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get(
        `https://api.fitoja.in/api/get-employee-details/${email}`,
        config
      );
      setUserDetails(response.data);
      setRole(response.data.role);
      fetchAllSubscriptionPlanss();
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      handleLogout();
    }
  };

  const fetchAllSubscriptionPlanss = async () => {
    try {
      const response = await axios.get(
        `https://api.fitoja.in/api/get-all-subscription-plans`
      );
      setSubscriptionPlanss(response.data.data);
    } catch (error) {
      console.error("Failed to fetch subscriptionPlans:", error);
    } finally {
      setLoading(false); // Stop the loading indicator once API responds
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleDelete = async () => {
    if (!subscriptionPlansToDelete) return;
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Authentication failed! Redirecting to login.");
        navigate("/login");
        return;
      }

      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(
        `https://api.fitoja.in/api/delete-subscription-plan/${subscriptionPlansToDelete._id}`,
        config
      );
      fetchAllSubscriptionPlanss();
      closeDeleteModal();
    } catch (error) {
      console.error("Failed to delete employee:", error);
      alert("Failed to delete employee. Please try again.");
    }
  };

  const openDeleteModal = (subscriptionPlans: SubscriptionPlans) => {
    setSubscriptionPlansToDelete(subscriptionPlans);
    setDeleteModalVisible(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalVisible(false);
    setSubscriptionPlansToDelete(null);
  };

  // Add new coupon code API call
  const handleAddSubscriptionPlans = async () => {
    try {
      await axios.post(
        `https://api.fitoja.in/api/create-subscription-plan`,
        newSubscriptionPlans
      );
      fetchAllSubscriptionPlanss();
      closeAddModal();
    } catch (error) {
      console.error("Failed to add employee:", error);
      alert("Failed to add employee. Please try again.");
    }
  };

  const openAddModal = () => {
    setAddModalVisible(true);
  };

  const closeAddModal = () => {
    setAddModalVisible(false);
    setNewSubscriptionPlans({
      planName: "",
      mrp: "",
      price: "",
      discount: "",
      description: "",
      durationInMonths: "",
    });
  };

  useEffect(() => {
    if (isInitialRender.current) {
      fetchUserDetails();
      isInitialRender.current = false;
    }
  }, []);

  return (
    <div className="subscription-plan">
      {/* Loading indicator */}
      {loading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading, please wait...</p>
        </div>
      )}

      {!loading && (
        <>
          <header className="dashboard-header">
            <div className="logo" onClick={() => navigate("/dashboard")}>
              <img src={logo} />
            </div>
            <div
              className="profile-section"
              onClick={() => setShowOverlay(!showOverlay)}
            >
              <img className="profile-pic" src={maleProfilePic} alt="Profile" />
            </div>
          </header>

          {showOverlay && userDetails && (
            <div className="profile-overlay">
              <div className="overlay-content">
                <img
                  className="close_icon"
                  onClick={() => setShowOverlay(false)}
                  src={closeIcon}
                />
                <p>
                  <strong>Name:</strong> {userDetails.name}
                </p>
                <p>
                  <strong>Email:</strong> {userDetails.email}
                </p>
                <p>
                  <strong>Phone Number:</strong> {userDetails.phoneNumber}
                </p>
                <p>
                  <strong>Role:</strong> {userDetails.role}
                </p>
                <p>
                  <strong>Gender:</strong> {userDetails.gender}
                </p>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}

          <h2 style={{ marginTop: "110px", marginBottom: "0px" }}>
            Subscription Plans
          </h2>

          <div className="create-new-subscription-plan" onClick={openAddModal}>
            <span>Create New Subscription Plan</span>
          </div>

          <hr></hr>

          <div className="subscription-plan-list">
            {subscriptionPlans.length > 0 ? (
              subscriptionPlans.map((subscriptionPlans) => (
                <div
                  key={subscriptionPlans._id}
                  className="subscription-plan-card"
                >
                  <div className="subscription-plan-details">
                    <p>
                      <strong>Plan Name:</strong>{" "}
                      <span>{subscriptionPlans?.planName}</span>
                    </p>
                    <p>
                      <strong>MRP:</strong>{" "}
                      <span>{subscriptionPlans?.mrp}</span>
                    </p>
                    <p>
                      <strong>Discount:</strong>{" "}
                      <span>{subscriptionPlans?.discount}</span>
                    </p>
                    <p>
                      <strong>Price:</strong>{" "}
                      <span>{subscriptionPlans?.price}</span>
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      <strong>About Plan:</strong>{" "}
                      <span>{parse(subscriptionPlans?.description)}</span>
                    </p>
                    <p>
                      <strong>Plan Duration:</strong>{" "}
                      <span>
                        {subscriptionPlans?.durationInMonths + " months"}
                      </span>
                    </p>
                  </div>
                  <div
                    className="delete-icon"
                    onClick={() => openDeleteModal(subscriptionPlans)}
                  >
                    <img className="img" src={deleteIcon}></img>
                  </div>
                </div>
              ))
            ) : (
              <p
                style={{
                  display: "flex",
                  height: "70vh",
                  alignItems: "center",
                }}
              >
                No Subscription Plan found
              </p>
            )}
          </div>

          {deleteModalVisible && (
            <div className="delete-modal">
              <div className="delete-modal-content">
                <h2>Delete Confirmation</h2>
                <p>Are you sure you want to delete this Subscription plan?</p>
                <span style={{ display: "flex", gap: "20px" }}>
                  <button onClick={closeDeleteModal} className="cancel-button">
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="confirm-delete-button"
                  >
                    Yes, Delete
                  </button>
                </span>
              </div>
            </div>
          )}

          {addModalVisible && (
            <div className="add-modal">
              <div className="add-modal-content">
                <h2>Create New Subcription Plan</h2>
                <form>
                  <input
                    type="text"
                    placeholder="Plan Name"
                    value={newSubscriptionPlans.planName}
                    onChange={(e) =>
                      setNewSubscriptionPlans({
                        ...newSubscriptionPlans,
                        planName: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="number"
                    placeholder="MRP (In ₹)"
                    value={newSubscriptionPlans.mrp}
                    onChange={(e) =>
                      setNewSubscriptionPlans({
                        ...newSubscriptionPlans,
                        mrp: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="number"
                    placeholder="Discount (In %)"
                    value={newSubscriptionPlans.discount}
                    onChange={(e) =>
                      setNewSubscriptionPlans({
                        ...newSubscriptionPlans,
                        discount: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="number"
                    placeholder="Price (In ₹)"
                    value={newSubscriptionPlans.price}
                    onChange={(e) =>
                      setNewSubscriptionPlans({
                        ...newSubscriptionPlans,
                        price: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="text"
                    placeholder="Plan Duration (In months)"
                    value={newSubscriptionPlans.durationInMonths}
                    onChange={(e) =>
                      setNewSubscriptionPlans({
                        ...newSubscriptionPlans,
                        durationInMonths: e.target.value,
                      })
                    }
                    required
                  />
                  {/* <input
                    type="text"
                    placeholder="Plan Description"
                    value={newSubscriptionPlans.description}
                    onChange={(e) =>
                      setNewSubscriptionPlans({
                        ...newSubscriptionPlans,
                        description: e.target.value,
                      })
                    }
                    required
                  /> */}
                  <label>Plan Description</label>
                  <ReactQuill
                    value={newSubscriptionPlans.description}
                    onChange={(value) =>
                      setNewSubscriptionPlans({
                        ...newSubscriptionPlans,
                        description: value,
                      })
                    }
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ align: [] }],
                        ["image"],
                        ["clean"], // Remove formatting
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "blockquote",
                      "code-block",
                      "list",
                      "bullet",
                      "align",
                      "link",
                      "image",
                    ]}
                  />
                  <button
                    type="button"
                    onClick={handleAddSubscriptionPlans}
                    className="subscription-plan-button"
                  >
                    Create Subscription Code
                  </button>
                  <button
                    type="button"
                    onClick={closeAddModal}
                    className="cancel-button"
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SubscriptionPlans;
